
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 137.99 143.36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M105.37 143.36L95 109.38H43l-10.35 34H0L50.39 0h37L138 143.36zM87.79 84Q73.44 37.79 71.63 31.74T69 22.17Q65.82 34.67 50.59 84z","fill":"#7a1713","opacity":".75"}})])
          )
        }
      }
    